import React from 'react';
import styled, { useTheme } from 'styled-components';
import { useMediaQuery } from "react-responsive";
import { MainContainer } from '../components/common/Containers';
import FAQList from '../components/common/FAQList';
import { joiningFaqs, contributionsFaqs, miscFaqs } from '../data/faqs';

export default function FAQs() {
    const theme = useTheme();
    const isMobile = useMediaQuery({ maxWidth: 600 });

    return (
        <MainContainer theme={theme}>
            <Section>
                <Header>
                    <h2 style={{ color: theme.textPrimary, fontSize: isMobile ? "1.15rem" : "1.5rem" }}>
                        MOST COMMON QUESTIONS
                    </h2>
                </Header>

                <FAQList faqs={joiningFaqs} />
                <FAQList faqs={contributionsFaqs} />
                <FAQList faqs={miscFaqs} />
            </Section>
        </MainContainer>
    );
}

// Styled Components
const Section = styled.div`
    width: "100%";
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 1.5rem;
    background: ${({ theme }) => theme.white};
    padding: 2rem;
    border-radius: 1.5rem;
    flex-wrap: wrap;

    @media (max-width: 600px) {
        padding: 2rem 1rem;
        gap: 1rem;
    }
`;

const Header = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    flex-wrap: wrap;

    @media (max-width: 600px) {
        align-items: center;
    }
`;

